import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { gauge } from "./constants";
import { FramesService } from "../../../routes/services/frames.service";
import { GlobalFunction } from "../../../routes/services/globalFuntion";
import { Subscription } from "rxjs";
import { StorageService } from "../../../routes/services/storage.service";

@Component({
  selector: "app-speed-view-feeder",
  templateUrl: "./speed.html",
  styleUrls: ["./speed.scss"]
})
export class SpeedViewFeederComponent implements OnInit {
  @Input() speed_bar = false;
  speed = {
    status_speed: gauge,
    status_low_speed: gauge,
    status_high_speed: gauge
  };

  @Input() feeder: null | any = null;
  enabledDisabledSpeed = false;
  view_speed_orbital = false;
  loading = {
    status_speed: "",
    get_speed: ""
  };

  /** Estado de encendido por modo; se mantiene sincronizado con feeder/status_speed_mode */
  private modeEnabled = {
    normal: false,
    orbital: false
  };

  socketSubsciption!: Subscription;
  optionSpeed = [37.5, 50, 62.5, 75, 87.5, 100];
  @Input() view_old_title = true;
  constructor(
    public framesService: FramesService,
    public globalFunction: GlobalFunction,
    public storageService: StorageService
  ) {}
  ngOnDestroy(): void {
    this.socketSubsciption.unsubscribe();
  }
  ngOnInit(): void {
    this.feeder && this.validateData();

    const frames = [
      "SPEED_CONFIG",
      "ORBITAL_SPEED",
      "SPEED_RESPONSE",
      "ALERT_Communication",
      "ALERT_COMM"
    ];

    this.socketSubsciption = this.storageService.watchStorage("socket").subscribe((msg: any) => {
      if (msg.data && msg.data.type) {
        const type = msg.data.type;
        if (this.feeder && frames.includes(type)) {
          let result = this.globalFunction.setDataFeeders([this.feeder], msg);
          const exist = result.feederChanged.find((item: any) => item.id === this.feeder.id);
          const statusByFrame = {
            SPEED_CONFIG: "status_speed",
            ORBITAL_SPEED: "status_speed",
            SPEED_RESPONSE: "get_speed"
          } as const;
          if (exist) {
            this.validateData();
            if (type === "SPEED_CONFIG" || type === "ORBITAL_SPEED" || type === "SPEED_RESPONSE") {
              const frameKey = type as keyof typeof statusByFrame;
              const loadingKey = statusByFrame[frameKey];
              if (this.loading[loadingKey] === "loading") {
                this.loading[loadingKey] = "done";
              }
            }

            if (type === "ALERT_Communication" || type === "ALERT_COMM") {
              (Object.keys(statusByFrame) as Array<keyof typeof statusByFrame>).forEach((key) => {
                const loadingKey = statusByFrame[key];
                if (this.loading[loadingKey] === "loading") {
                  this.loading[loadingKey] = "error";
                }
              });
            }
          }
        }
      }
    });
  }

  ngOnChanges(): void {
    this.feeder && this.validateData();
  }

  /**
   * Enciende o apaga el modo actualmente seleccionado por los radios.
   * @param enabled - estado actual del switch (true = encendido)
   */
  changeStatusSpeed(enabled: boolean): void {
    const { id } = this.feeder;
    this.loading.status_speed = "loading";
    const speed_normal = !this.view_speed_orbital;
    let query = `?id_in=${id}`;

    /* Flujo para modo normal */
    if (speed_normal) {
      if (enabled) {
        this.framesService.Frame("disable_speed", query).subscribe(
          (resp) => {
            if (resp && resp.hasOwnProperty("errors")) {
              this.enabledDisabledSpeed = false;
              this.validateGatewayFeeder(resp.errors);
            } else {
              this.setModeEnabled("normal", false);
            }
          },
          (err) => {
            this.enabledDisabledSpeed = false;
          }
        );
      } else {
        this.framesService.Frame(`enable_speed`, query).subscribe(
          (resp) => {
            this.feeder.enable_speed = true;
            this.feeder.orbital_enabled = false;
            if (resp && resp.hasOwnProperty("errors")) {
              this.enabledDisabledSpeed = true;
              this.validateGatewayFeeder(resp.errors);
            } else {
              this.setModeEnabled("normal", true);
            }
          },
          (err) => {
            this.enabledDisabledSpeed = true;
          }
        );
      }
    } else {
      /* Flujo para modo orbital */
      if (enabled) {
        this.framesService.Frame("disable_orbital", query).subscribe((resp) => {
          if (resp && resp.hasOwnProperty("errors")) {
            this.enabledDisabledSpeed = false;
            this.validateGatewayFeeder(resp.errors);
          } else {
            this.setModeEnabled("orbital", false);
          }
        });
      } else {
        const values: Array<"status_low_speed" | "status_high_speed"> = [
          "status_low_speed",
          "status_high_speed"
        ];

        let obj: { status_low_speed: number; status_high_speed: number } = {
          status_low_speed: 0,
          status_high_speed: 0
        };
        values.forEach((val) => {
          obj[val] = this.sliderValue(val);
        });
        const val = {
          orbital_enabled: true,
          low: obj.status_low_speed,
          high: obj.status_high_speed
        };
        this.framesService.Frame(`enable_orbital`, query, val).subscribe(
          (resp) => {
            if (resp && resp.hasOwnProperty("errors")) {
              this.enabledDisabledSpeed = false;
              this.validateGatewayFeeder(resp.errors);
            } else {
              this.setModeEnabled("orbital", true);
            }
          },
          (err) => {
            setTimeout(() => {
              this.enabledDisabledSpeed = false;
            }, 100);
          }
        );
      }
    }
  }

  /**
   * Sincroniza el modo activo/encendido local con la data del feeder.
   */
  validateData = () => {
    const statusMode = Number(this.feeder && this.feeder.status_speed_mode);
    const normalEnabled = statusMode === 1 || !!(this.feeder && this.feeder.enable_speed);
    const orbitalEnabled = statusMode === 2 || !!(this.feeder && this.feeder.orbital_enabled);

    this.modeEnabled.normal = normalEnabled && !orbitalEnabled;
    this.modeEnabled.orbital = orbitalEnabled;
    this.view_speed_orbital = this.modeEnabled.orbital;
    this.enabledDisabledSpeed = this.view_speed_orbital
      ? this.modeEnabled.orbital
      : this.modeEnabled.normal;

    if (this.view_speed_orbital) {
      const val: Array<"status_low_speed" | "status_high_speed"> = [
        "status_low_speed",
        "status_high_speed"
      ];
      val.forEach((value) => {
        this.setValueChart(value, this.feeder[value]);
      });
    } else {
      this.setValueChart("status_speed", this.feeder["status_speed"]);
    }
  };

  clickChart(e: any, type: "status_speed" | "status_low_speed" | "status_high_speed"): void {
    const x = e.event.event.offsetX;
    const totalWidth = e.event.event.target.clientWidth;
    const percentage = (x / totalWidth) * 100;
    const values = [37.5, 50, 62.5, 75, 87.5, 100];
    const range = percentage / ((1 / values.length) * 100);
    let index = Math.round(Number(range));
    if (percentage < 17) {
      index = 0;
    }
    this.setValueChart(type, values[index]);
  }
  setValueChart(
    type: "status_speed" | "status_low_speed" | "status_high_speed",
    value: number
  ): void {
    this.speed[type] = {
      ...this.speed[type],
      series: [
        {
          ...this.speed[type].series[0]
        },
        {
          ...this.speed[type].series[1],
          data: [{ value }]
        }
      ]
    };
  }
  changeInput(type: "status_speed" | "orbital"): void {
    this.view_speed_orbital = type !== "status_speed";
    this.enabledDisabledSpeed = this.view_speed_orbital
      ? this.modeEnabled.orbital
      : this.modeEnabled.normal;
  }
  getSpeed() {
    if (this.feeder) {
      this.framesService.individualFrames(this.feeder.id, "request_speed", {}).subscribe((resp) => {
        this.loading.get_speed = "loading";
        if (resp && resp.hasOwnProperty("errors")) {
          this.loading.get_speed = "error";
          this.validateGatewayFeeder(resp.errors);
        }
      });
    }
  }
  sendValue() {
    const values: Array<"status_speed" | "status_low_speed" | "status_high_speed"> = [
      "status_speed",
      "status_low_speed",
      "status_high_speed"
    ];
    let speedValues: Record<"status_speed" | "status_low_speed" | "status_high_speed", number> = {
      status_speed: 37.5,
      status_low_speed: 37.5,
      status_high_speed: 37.5
    };

    values.forEach((val) => {
      speedValues[val] = this.sliderValue(val);
    });
    const { id, status_version } = this.feeder;

    let petition: "set_orbital_speed" | "set_speed" = this.view_speed_orbital
      ? "set_orbital_speed"
      : "set_speed";

    let payload: any;

    /*
     * Al guardar configuración se debe encender el modo seleccionado:
     * 1) enviar set_speed / set_orbital_speed
     * 2) enviar enable_speed / enable_orbital
     */

    /* Version 5 hardcodeada */
    if (status_version === "NAS0.5") {
      petition = "set_orbital_speed";
      payload = {
        high: speedValues.status_speed,
        low: speedValues.status_speed,
        orbital_enabled: true
      };
    } else if (this.view_speed_orbital) {
      payload = {
        high: speedValues.status_high_speed,
        low: speedValues.status_low_speed,
        orbital_enabled: true
      };
    } else {
      payload = {
        speed: speedValues.status_speed
      };
    }

    this.loading.status_speed = "loading";
    this.framesService.individualFrames(id, petition, payload).subscribe((resp) => {
      if (resp && resp.hasOwnProperty("errors")) {
        this.validateGatewayFeeder(resp.errors);
        return;
      }
      /* Se guardan los valores enviados para que el encendido use estos y no los anteriores */
      if (payload.speed !== undefined) {
        this.feeder.status_speed = payload.speed;
      }
      if (payload.low !== undefined) {
        this.feeder.status_low_speed = payload.low;
        this.feeder.status_high_speed = payload.high;
      }
      this.enableSelectedMode(id);
    });
  }

  /**
   * Enciende el modo actualmente seleccionado (normal/orbital).
   * Se llama después de enviar una nueva configuración.
   */
  private enableSelectedMode(id: number): void {
    const query = `?id_in=${id}`;
    if (this.view_speed_orbital) {
      const payload = {
        orbital_enabled: true,
        low: this.sliderValue("status_low_speed"),
        high: this.sliderValue("status_high_speed")
      };
      this.framesService.Frame("enable_orbital", query, payload).subscribe((resp) => {
        if (resp && resp.hasOwnProperty("errors")) {
          this.validateGatewayFeeder(resp.errors);
          return;
        }
        this.setModeEnabled("orbital", true);
      });
      return;
    }

    this.framesService.Frame("enable_speed", query).subscribe((resp) => {
      if (resp && resp.hasOwnProperty("errors")) {
        this.validateGatewayFeeder(resp.errors);
        return;
      }
      this.setModeEnabled("normal", true);
    });
  }

  /**
   * Actualiza flags locales del switch respetando exclusividad entre modos.
   * @param mode - modo a actualizar
   * @param enabled - estado de encendido
   */
  private setModeEnabled(mode: "normal" | "orbital", enabled: boolean): void {
    if (mode === "normal") {
      this.modeEnabled.normal = enabled;
      this.modeEnabled.orbital = enabled ? false : this.modeEnabled.orbital;
      this.feeder.status_speed_mode = enabled ? 1 : this.modeEnabled.orbital ? 2 : 0;
      this.feeder.enable_speed = enabled;
      this.feeder.orbital_enabled = this.modeEnabled.orbital;
    } else {
      this.modeEnabled.orbital = enabled;
      this.modeEnabled.normal = enabled ? false : this.modeEnabled.normal;
      this.feeder.status_speed_mode = enabled ? 2 : this.modeEnabled.normal ? 1 : 0;
      this.feeder.orbital_enabled = enabled;
      this.feeder.enable_speed = this.modeEnabled.normal;
    }
    this.enabledDisabledSpeed = this.view_speed_orbital
      ? this.modeEnabled.orbital
      : this.modeEnabled.normal;
  }
  /**
   * Valor actual de un slider de velocidad. Los sliders escriben directo en el
   * alimentador vía ngModel (como texto), así que se convierte a número.
   * @param type Velocidad a leer.
   * @returns Valor seleccionado; 37.5 (mínimo) si no hay valor.
   */
  private sliderValue(type: "status_speed" | "status_low_speed" | "status_high_speed"): number {
    const value = Number(this.feeder && this.feeder[type]);
    return value ? value : 37.5;
  }

  validateGatewayFeeder(error: any): void {
    for (const key in error) {
      if (Object.prototype.hasOwnProperty.call(error, key)) {
        const msg = error[key];
        this.globalFunction.animation("error", msg, "");
      }
    }
    this.loading.status_speed = "error";
  }
  validateInputsSpeed(
    input:
      | "status_high_speed"
      | "status_low_speed"
      | "status_speed"
      | "view_mode_speed"
      | "option_type"
  ) {
    return this.feeder[input] ? this.feeder[input] : 37.5;
  }
}
